/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'email': {
    width: 26,
    height: 21,
    viewBox: '0 0 26 21',
    data: '<path pid="0" _fill="#008cff" d="M25.254 3.7v13.287c0 1.87-1.446 3.392-3.226 3.392h-18.9c-1.78 0-3.227-1.521-3.227-3.392V3.694c0-1.871 1.447-3.392 3.227-3.392h18.905c1.78 0 3.227 1.527 3.221 3.397zM23.78 16.986V3.7c0-1.015-.786-1.842-1.752-1.842h-18.9c-.967 0-1.753.827-1.753 1.842v13.288c0 1.016.786 1.842 1.753 1.842h18.905c.967 0 1.753-.826 1.753-1.842zm-.536-.078c.332.33.344.886.03 1.235a.803.803 0 01-1.174.032l-6.875-6.866-2.072 1.952a.803.803 0 01-.554.226.807.807 0 01-.553-.22l-2.017-1.893L3.11 18.17a.81.81 0 01-.565.233.83.83 0 01-.609-.278.908.908 0 01.037-1.235l6.808-6.692-6.839-6.394a.903.903 0 01-.067-1.235.801.801 0 011.174-.071l7.441 6.97c.05.039.092.077.135.123 0 .006.007.013.013.019l1.955 1.836L22.1 2.504a.806.806 0 011.175.065.909.909 0 01-.062 1.235l-6.752 6.336z"/>'
  }
})
